@if (type === SearchType.Page) {
    @for (result of searchResults.Page; track result) {
        <adapt-search-row-page [result]="result"></adapt-search-row-page>
    }
}
@if (type === SearchType.PersonTeamRole) {
    @for (result of searchResults.PersonTeamRole; track result) {
        @if (SearchService.isPerson(result); as person) {
            <adapt-search-row-person [result]="person"></adapt-search-row-person>
        }
        @if (SearchService.isTeam(result); as team) {
            <adapt-search-row-team [result]="team"></adapt-search-row-team>
        }
    }
}
@if (type === SearchType.Kanban) {
    @for (result of searchResults.Kanban; track result) {
        <adapt-search-row-kanban [result]="result"></adapt-search-row-kanban>
    }
}
@if (type === SearchType.Meeting) {
    @for (result of searchResults.Meeting; track result) {
        <adapt-search-row-meeting [result]="result"></adapt-search-row-meeting>
    }
}
@if (type === SearchType.Objective) {
    @for (result of sortedObjectiveResults; track result) {
        <adapt-search-row-objective [result]="result"></adapt-search-row-objective>
    }
}
@if (type === SearchType.Guidance) {
    @for (result of sortedGuidanceResults; track result) {
        @if (SearchService.isPurposeVision(result); as purposeVision) {
            <adapt-search-row-purpose-vision [result]="purposeVision"></adapt-search-row-purpose-vision>
        }
        @if (SearchService.isValue(result); as value) {
            <adapt-search-row-value [result]="value"></adapt-search-row-value>
        }
        @if (SearchService.isStrategicTheme(result); as theme) {
            <adapt-search-row-strategic-theme [result]="theme"></adapt-search-row-strategic-theme>
        }
        @if (SearchService.isStrategicGoal(result); as goal) {
            <adapt-search-row-strategic-goal [result]="goal"></adapt-search-row-strategic-goal>
        }
        @if (SearchService.isStrategicAnchor(result); as anchor) {
            <adapt-search-row-strategic-anchor [result]="anchor"></adapt-search-row-strategic-anchor>
        }
        @if (SearchService.isStrengthWeaknessTrend(result); as swt) {
            <adapt-search-row-strength-weakness-trend [result]="swt"></adapt-search-row-strength-weakness-trend>
        }
        @if (SearchService.isCompetitorAnalysis(result); as ca) {
            <adapt-search-row-competitor-analysis [result]="ca"></adapt-search-row-competitor-analysis>
        }
        @if (SearchService.isBullseye(result); as bullseye) {
            <adapt-search-row-bullseye [result]="bullseye"></adapt-search-row-bullseye>
        }
    }
}
